import React, { FC, useState } from "react";
import { Spin, Form, Input, Button, Radio, InputNumber } from "antd";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";

import "./App.css";

type Choice = "wwf" | "climate" | "umom";

const { TextArea } = Input;
interface RadioButtonProps {
  value: Choice;
  label: string;
}

const choices: RadioButtonProps[] = [
  { value: "wwf", label: "WWF" },
  { value: "climate", label: "Carbon Capture" },
  { value: "umom", label: "UMOM" },
];

interface Values {
  name: string;
  message: string;
  email: string;
  cause: Choice;
  amount: number;
}

function DonateForm() {
  const [loading, setLoading] = useState(false);

  const onFinish = async ({ amount, cause, ...metadata }: Values) => {
    setLoading(true);
    const res = await fetch("/.netlify/functions/create-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: amount * 100,
        cause,
        origin: window.location.origin,
        metadata,
        currency: "usd",
      }),
    });
    const data = await res.json();
    console.log(data);
    window.location.href = data.url;
  };

  if (loading) {
    return <Spin size="large" />;
  }

  return (
    <Form
      name="donate"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <div className="form-example">
        <Form.Item
          label="Your name(s)"
          name="name"
          rules={[{ required: true, message: "Please add your name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please add your email" }]}
        >
          <Input type="email" />
        </Form.Item>
        <Form.Item label="Message to Devin & Viktor" name="message">
          <TextArea />
        </Form.Item>
        <Form.Item
          label="Cause"
          name="cause"
          rules={[
            {
              required: true,
              message: "Please specify the cause you would like to donate to",
            },
          ]}
        >
          <Radio.Group>
            {choices.map((c) => (
              <Radio.Button value={c.value} key={c.value}>
                {c.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Amount"
          name="amount"
          rules={[
            {
              required: true,
              message: "Please specify the amount you would like to donate",
            },
          ]}
        >
          <InputNumber addonAfter="USD" precision={0} />
        </Form.Item>
        <div id="buttoncont">
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large">
              Donate
            </Button>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
}

const Wrapper: FC = ({ children }) => {
  return (
    <div className="App">
      <header className="App-header">
        <div className="content">{children}</div>
      </header>
    </div>
  );
};

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Success = () => {
  const query = useQuery();
  const amount = query.get("amount");
  const cause = query.get("cause");
  const currency = query.get("currency") || "USD";
  return (
    <Wrapper>
      <h2>Thank you for your donation!</h2>
      {amount && (
        <p>
          Amount: {amount} {currency}
        </p>
      )}
      {cause && <p>Cause: {choices.find((c) => c.value === cause)?.label}</p>}
    </Wrapper>
  );
};

const Main: FC = () => {
  return (
    <Wrapper>
      <h1>Donation Form</h1>
      <DonateForm />
    </Wrapper>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
